"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstitutionType;
(function (InstitutionType) {
    InstitutionType[InstitutionType["Unknown"] = 0] = "Unknown";
    InstitutionType[InstitutionType["Doctor"] = 1] = "Doctor";
    InstitutionType[InstitutionType["NursingHome"] = 2] = "NursingHome";
    InstitutionType[InstitutionType["NursingService"] = 3] = "NursingService";
    InstitutionType[InstitutionType["Hospital"] = 4] = "Hospital";
    InstitutionType[InstitutionType["Payer"] = 5] = "Payer";
    InstitutionType[InstitutionType["Pharmacy"] = 6] = "Pharmacy";
    InstitutionType[InstitutionType["JointPractice"] = 7] = "JointPractice";
    // 99 is reserved in related enum refferer-type.ts
})(InstitutionType = exports.InstitutionType || (exports.InstitutionType = {}));
